/*
	Quick JS by Jason @ freakdesign.
	Questions? Ping me on twitter: @freakdesign
	Relates to blog post:
	https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
	Example:
	https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

	Ajuste Efizi (2026-07): o resultado do frete aparece SEMPRE; quando o CEP é de
	outra região, o aviso de troca vira uma faixa inline abaixo do resultado (com o
	preço da região explicado), em vez do modal cobrir o cálculo. O prazo e o custo
	do frete são cotados pelo CEP digitado, então continuam corretos; o que depende
	da região é o preço do produto, e é isso que o aviso explica.
*/
(function () {
	"use strict";
	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;
	var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if (shippingCalcExist) return;
	/* The ID of the element that you want to add the shipping fields into */
	var productSection = document.querySelector('.shopping-calculator');
	if (!productSection) { log('Could not find the element'); return }
	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	if (!productSelect) { log('Could not find the main select element'); return }
	/* create a message box */
	var shippingMessage = document.createElement('p');
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
	/* Aviso inline de região (substitui o modal na frente do resultado).
	   Registro visual: é informação, não erro do cliente, então usa a família
	   "info" do design system (teal) em vez de amarelo de alerta. */
	var regionWarn = document.createElement('div');
	regionWarn.className = 'shipping-calc-region-warn';
	regionWarn.style.cssText = 'display:none;margin-top:10px;padding:10px 12px;background:#E9F3F1;border:1px solid #C7DFDA;border-radius:8px;font-size:13px;line-height:1.5;color:#0A0A0A;';
	/* Nomes das regiões saem do próprio <select> do header, então uma região
	   nova entra sozinha aqui. Só dois rótulos ganham forma de texto corrido:
	   "São Paulo - Grande SP" e "São Paulo - Interior" não cabem numa frase. */
	var ROTULO = { '123456': 'Grande São Paulo', '123457': 'interior de São Paulo' };
	var nomesDeRegiao = function () {
		var mapa = {};
		var opts = document.querySelectorAll('#region-selector option');
		for (var i = 0; i < opts.length; i++) {
			if (opts[i].value) { mapa[opts[i].value] = ROTULO[opts[i].value] || opts[i].textContent.trim(); }
		}
		return mapa;
	};
	/* Artigo por região, pra frase sair natural: "o preço é o DA Bahia",
	   "esse CEP fica NO Acre". Região fora da lista cai no neutro (de/em), que
	   é justamente o certo pra nome sem artigo: "de Minas Gerais", "em Mato
	   Grosso". Então esquecer de cadastrar uma região nova não quebra o texto. */
	var ARTIGO = {
		'Acre': 'o', 'Amapá': 'o', 'Amazonas': 'o', 'Ceará': 'o', 'Distrito Federal': 'o',
		'Espírito Santo': 'o', 'Maranhão': 'o', 'Pará': 'o', 'Paraná': 'o', 'Piauí': 'o',
		'Rio de Janeiro': 'o', 'Rio Grande do Norte': 'o', 'Rio Grande do Sul': 'o',
		'Tocantins': 'o', 'interior de São Paulo': 'o',
		'Bahia': 'a', 'Paraíba': 'a', 'Grande São Paulo': 'a'
	};
	var comDe = function (nome) {
		var a = ARTIGO[nome];
		return (a === 'o' ? 'do ' : a === 'a' ? 'da ' : 'de ') + nome;
	};
	var comEm = function (nome) {
		var a = ARTIGO[nome];
		return (a === 'o' ? 'no ' : a === 'a' ? 'na ' : 'em ') + nome;
	};
	var comPara = function (nome) {
		var a = ARTIGO[nome];
		return (a === 'o' ? 'para o ' : a === 'a' ? 'para a ' : 'para ') + nome;
	};
	/* Regiões em que essa variante não é vendida (vem do main-product.liquid).
	   Sem isso o modal convidaria o cliente pra uma página sem preço e sem
	   botão de compra, que é o que a PDP mostra numa região não atendida. */
	var regioesSemProduto = function () {
		var el = document.querySelector('[data-efizi-unavail]');
		if (!el) return [];
		return (el.getAttribute('data-efizi-unavail') || '')
			.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
	};
	/* Descobre a região do CEP digitado. Mesma varredura do changeRegionByZip
	   (theme.liquid), só que normalizando pra dígitos: o original compara a
	   string crua, então "40010-000" escapava da própria faixa. */
	var regiaoDoCep = function (zip) {
		try {
			if (typeof allRegions === 'undefined') return null;
			var z = Number(String(zip).replace(/\D/g, ''));
			if (!z) return null;
			var achou = null;
			allRegions.forEach(function (r) {
				(r.regionZipRange || []).forEach(function (faixa) {
					if (achou) return;
					var ini = Number(String(faixa.inicio).replace(/\D/g, ''));
					var fim = Number(String(faixa.fim).replace(/\D/g, ''));
					if (z >= ini && z <= fim) { achou = String(r.regionId); }
				});
			});
			return achou;
		} catch (e) { return null; }
	};
	/* Trocar de região limpa o carrinho (theme.liquid chama /cart/clear). Só
	   vale avisar disso quando existe carrinho pra perder. Recebe uma lista de
	   alvos porque o mesmo recado vai no aviso inline e no modal. */
	var avisaCarrinho = function (alvos) {
		fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (c) {
				if (!c || !c.item_count) return;
				alvos.forEach(function (alvo) {
					if (alvo && alvo.isConnected) { alvo.innerHTML = ' Isso também esvazia o carrinho.'; }
				});
			})
			.catch(function () { /* sem carrinho conhecido, não promete nada */ });
	};
	/* Modal de região, agora carregando o prazo dentro.
	   Antes ele abria ANTES da cotação e cobria o resultado; agora abre depois,
	   levando junto o que o cliente pediu, e oferece as duas saídas de forma
	   explícita em vez de só um X. Os textos originais do tema são guardados e
	   restaurados no fechamento, porque esse mesmo modal é aberto por outros
	   caminhos (carrinho) que não passam por aqui. */
	/* Cidade do CEP, via ViaCEP (grátis, sem chave, CORS liberado). É enfeite
	   útil, não dependência: se cair ou demorar, o card fica só com o CEP e
	   nada quebra. A busca é disparada junto com a cotação, que leva bem mais
	   tempo, então a cidade já chega pronta na hora de desenhar.
	   A cidade entra SÓ na etiqueta do card, onde "entrega para X" funciona pra
	   qualquer nome. Em texto corrido daria erro de artigo ("de Rio de
	   Janeiro"), e o corpo do modal já usa o nome da região, que tem artigo
	   mapeado. */
	var cidadeCache = {};
	var buscaCidade = function (digitos) {
		if (!/^\d{8}$/.test(digitos)) return Promise.resolve(null);
		if (cidadeCache[digitos]) return cidadeCache[digitos];
		cidadeCache[digitos] = fetch('https://viacep.com.br/ws/' + digitos + '/json/')
			.then(function (r) { return r.json(); })
			.then(function (d) {
				return (d && d.localidade && !d.erro) ? d.localidade + ', ' + d.uf : null;
			})
			.catch(function () { return null; });
		return cidadeCache[digitos];
	};
	/* Card de prazo do modal. Montado a partir dos dados da cotação, e não do
	   HTML do resultado da página: aquele vem como <ul><li> com marcador de
	   lista e um verde #00AA00 que não é da marca. Aqui a hierarquia é o valor
	   primeiro, o prazo depois, e o CEP como etiqueta discreta em cima. */
	var cardPrazo = function (cep, rates) {
		var linhas = '';
		for (var i = 0; i < rates.length; i++) {
			var r = rates[i];
			var dias = '';
			if (r.delivery_days && r.delivery_days.length > 0) {
				dias = r.delivery_days[0] == 1 ? '1 dia útil' : r.delivery_days[0] + ' dias úteis';
			}
			var gratis = !(Number(r.price) > 0);
			var valor = gratis ? 'Grátis' : 'R$ ' + String(r.price).replace('.', ',');
			linhas += '<div class="efizi-prazo__linha">' +
				'<strong class="efizi-prazo__valor' + (gratis ? ' efizi-prazo__valor--gratis' : '') + '">' + valor + '</strong>' +
				(dias ? '<span class="efizi-prazo__sep">·</span><span class="efizi-prazo__dias">' + dias + '</span>' : '') +
				'</div>';
		}
		return '<span class="efizi-prazo__label" data-efizi-prazo-label>Entrega para ' + cep + '</span>' + linhas;
	};
	var modalOriginais = null;
	var abreModalRegiao = function (dados) {
		var raiz = document.getElementById('region-alert-trigger');
		raiz = raiz && raiz.closest('details');
		if (!raiz) return null;
		var titulo = raiz.querySelector('[data-region-alert-title]');
		var sub = raiz.querySelector('[data-region-alert-subtitle]');
		var prazo = raiz.querySelector('[data-region-alert-prazo]');
		var trocar = raiz.querySelector('[data-region-change-button]');
		var ficar = raiz.querySelector('[data-region-alert-stay]');
		/* rodapé genérico do tema: some aqui, porque o subtítulo já diz o que
		   muda de verdade (preço e carrinho) de forma mais direta */
		var nota = raiz.querySelector('.region-selector-modal__text');
		/* tema sem os slots novos: cai no comportamento antigo em vez de quebrar */
		if (!titulo || !sub || !prazo || !trocar || !ficar) { return null; }
		if (!modalOriginais) {
			modalOriginais = { titulo: titulo.innerHTML, sub: sub.innerHTML, trocar: trocar.innerHTML };
		}
		var restaura = function () {
			titulo.innerHTML = modalOriginais.titulo;
			sub.innerHTML = modalOriginais.sub;
			trocar.innerHTML = modalOriginais.trocar;
			prazo.style.display = 'none';
			prazo.innerHTML = '';
			ficar.style.display = 'none';
			if (nota) { nota.style.display = ''; }
		};
		titulo.innerText = 'Esse CEP é ' + comDe(dados.destino);
		if (dados.semProduto) {
			/* não prometer preço onde não há produto: lá a PDP não tem preço nem
			   botão de compra. Vale trocar mesmo assim, pro site inteiro passar a
			   falar a verdade sobre esse destino.
			   O CEP é destino de ENTREGA, não o endereço de quem compra: dá pra
			   estar em São Paulo comprando pra uma obra no Acre. Por isso a frase
			   fala de entrega e de região, nunca de onde a pessoa está. */
			sub.innerHTML = 'A gente ainda não entrega esse produto ' + comEm(dados.destino) +
				'. Trocar a região ' + comPara(dados.destino) + ' mostra o que entregamos lá.' +
				'<span data-region-alert-cart></span>';
			trocar.innerText = 'Trocar ' + comPara(dados.destino);
		} else {
			sub.innerHTML = 'O preço na tela é <b>' + comDe(dados.atual) + '</b>. Trocar ' +
				comPara(dados.destino) + ' atualiza o preço.<span data-region-alert-cart></span>';
			trocar.innerText = 'Ver preço ' + comPara(dados.destino);
		}
		if (dados.temPrazo && dados.rates && dados.rates.length) {
			/* o prazo ganha etiqueta com o CEP: solto num modal que fala de duas
			   regiões, o número não diz a quem pertence. Conferido que a cotação
			   segue o CEP de destino e não muda com a região, então dá pra
			   afirmar isso sem ressalva. */
			prazo.innerHTML = cardPrazo(dados.cep, dados.rates);
			prazo.style.display = 'block';
			buscaCidade(dados.digitos).then(function (cidade) {
				var rot = prazo.querySelector('[data-efizi-prazo-label]');
				/* só reescreve se o card ainda for desse mesmo CEP */
				/* com a cidade, o CEP sai da etiqueta: ele já está no campo logo
				   acima, e os dois juntos quebravam em duas linhas no celular */
				if (cidade && rot && rot.innerText.indexOf(dados.cep) > -1) {
					rot.innerText = 'Entrega para ' + cidade;
				}
			});
		} else {
			prazo.style.display = 'none';
			prazo.innerHTML = '';
		}
		trocar.dataset.zip = dados.digitos;
		ficar.innerText = dados.semProduto
			? 'Continuar vendo esta página'
			: 'Continuar com o preço ' + comDe(dados.atual);
		if (dados.semProduto) { trocar.innerText = 'Trocar a região ' + comPara(dados.destino); }
		ficar.style.display = 'inline-block';
		if (nota) { nota.style.display = 'none'; }
		ficar.onclick = function () {
			restaura();
			if (raiz.hasAttribute('open')) { raiz.removeAttribute('open'); }
		};
		var fechar = raiz.querySelector('.region-selector-modal__close');
		if (fechar) { fechar.addEventListener('click', restaura, { once: true }); }
		if (!raiz.hasAttribute('open')) { raiz.setAttribute('open', ''); }
		return sub.querySelector('[data-region-alert-cart]');
	};
	/* Mostra ou esconde o aviso inline. A guarda comercial continua de pé: o
	   preço da página é o da região setada e só muda por ação explícita do
	   cliente, no botão abaixo. O que mudou é que ele vê o frete primeiro e o
	   botão promete uma coisa concreta ("ver preço para Minas Gerais") em vez
	   de abrir um seletor pra ele se achar de novo. */
	var updateRegionWarn = function (zip, temPrazo, rates) {
		var esconde = function () { regionWarn.style.display = 'none'; regionWarn.innerHTML = ''; };
		var atualId = new URLSearchParams(window.location.search).get('region_id');
		var destinoId = regiaoDoCep(zip);
		/* sem região na página, ou CEP da mesma região, ou CEP que não caiu em
		   faixa nenhuma: não há nada de útil a dizer */
		if (!atualId || !destinoId || destinoId === String(atualId)) { return esconde(); }
		var nomes = nomesDeRegiao();
		var atual = nomes[atualId];
		var destino = nomes[destinoId];
		if (!atual || !destino) { return esconde(); }
		var digitos = String(zip).replace(/\D/g, '');
		var semProduto = regioesSemProduto().indexOf(String(destinoId)) > -1;
		var btn = document.querySelector('[data-region-change-button]');
		if (btn) { btn.dataset.zip = digitos; }
		/* sem cotação na tela não existe "prazo acima" pra confirmar, então a
		   frase perde a primeira parte em vez de prometer o que não tem */
		if (semProduto) {
			regionWarn.innerHTML =
				'Esse CEP fica <b>' + comEm(destino) + '</b>, e a gente ainda não entrega esse produto lá. ' +
				'<a href="#" style="color:#1C6B5E;font-weight:600;text-decoration:underline;">Trocar a região ' + comPara(destino) + '</a>' +
				'<span class="shipping-calc-region-warn__cart"></span>';
		} else {
			regionWarn.innerHTML =
				(temPrazo ? 'O prazo acima está certo. Só o preço na tela é <b>' : 'O preço na tela é <b>') + comDe(atual) +
				'</b>, e esse CEP fica <b>' + comEm(destino) + '</b>. ' +
				'<a href="#" style="color:#1C6B5E;font-weight:600;text-decoration:underline;">Ver preço ' + comPara(destino) + '</a>' +
				'<span class="shipping-calc-region-warn__cart"></span>';
		}
		var link = regionWarn.querySelector('a');
		link.onclick = function (ev) {
			ev.preventDefault();
			link.innerText = 'Carregando...';
			/* caminho bom: já sabemos a região, então vai direto (e o
			   theme.liquid cuida de limpar carrinho e recarregar) */
			if (typeof manageRegion !== 'undefined' && manageRegion && manageRegion.changeRegionByZip) {
				manageRegion.changeRegionByZip(digitos);
			} else if (typeof openRegionAlert === 'function') {
				openRegionAlert();
			}
			return false;
		};
		regionWarn.style.display = 'block';
		/* O modal é o momento da decisão, com o prazo dentro; o aviso inline é
		   o rastro que fica depois que ele fecha. */
		var cepBonito = digitos.length === 8 ? digitos.slice(0, 5) + '-' + digitos.slice(5) : digitos;
		var alvoCarrinhoModal = abreModalRegiao({
			atual: atual, destino: destino, digitos: digitos, cep: cepBonito,
			temPrazo: temPrazo, rates: rates, semProduto: semProduto
		});
		avisaCarrinho([regionWarn.querySelector('.shipping-calc-region-warn__cart'), alvoCarrinhoModal]);
	};
	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function () {
		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i === 0));
		};
		shippingCountry.name = 'shipping_address[country]';
		/* create the province state picker */
		var provinces = ['Santa Catarina'];
		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
		};
		shippingProvince.name = 'shipping_address[province]';
		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
		shippingZip.pattern = '[0-9]*';
		shippingZip.inputMode = 'numeric';
		shippingZip.value = '';
		shippingZip.placeholder = 'Insira seu CEP';
		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';
		/* create a not know my zip code message */
		var shippingCalcNoZip = document.createElement('a');
		shippingCalcNoZip.className = 'shipping-calc-no-zip';
		shippingCalcNoZip.innerText = 'Não sei meu CEP';
		shippingCalcNoZip.href = 'https://buscacepinter.correios.com.br/app/endereco/index.php';
		shippingCalcNoZip.target = '_blank';
		/* create a icon */
		var shippingCalcIcon = document.createElement('span');
		var shippinIconHtml = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.1956 10.9688L21.8831 7.6875C21.7718 7.40988 21.5796 7.17209 21.3316 7.00494C21.0835 6.83778 20.791 6.74897 20.4919 6.75H17.25V6C17.25 5.80109 17.171 5.61032 17.0303 5.46967C16.8897 5.32902 16.6989 5.25 16.5 5.25H2.25C1.85218 5.25 1.47064 5.40804 1.18934 5.68934C0.908035 5.97064 0.75 6.35218 0.75 6.75V17.25C0.75 17.6478 0.908035 18.0294 1.18934 18.3107C1.47064 18.592 1.85218 18.75 2.25 18.75H3.84375C4.00898 19.3953 4.38428 19.9673 4.91048 20.3757C5.43669 20.7842 6.08387 21.0059 6.75 21.0059C7.41613 21.0059 8.06331 20.7842 8.58952 20.3757C9.11573 19.9673 9.49102 19.3953 9.65625 18.75H14.3438C14.509 19.3953 14.8843 19.9673 15.4105 20.3757C15.9367 20.7842 16.5839 21.0059 17.25 21.0059C17.9161 21.0059 18.5633 20.7842 19.0895 20.3757C19.6157 19.9673 19.991 19.3953 20.1563 18.75H21.75C22.1478 18.75 22.5294 18.592 22.8107 18.3107C23.092 18.0294 23.25 17.6478 23.25 17.25V11.25C23.2503 11.1536 23.2318 11.0581 23.1956 10.9688ZM17.25 8.25H20.4919L21.3919 10.5H17.25V8.25ZM2.25 6.75H15.75V12.75H2.25V6.75ZM6.75 19.5C6.45333 19.5 6.16332 19.412 5.91665 19.2472C5.66997 19.0824 5.47771 18.8481 5.36418 18.574C5.25065 18.2999 5.22094 17.9983 5.27882 17.7074C5.3367 17.4164 5.47956 17.1491 5.68934 16.9393C5.89912 16.7296 6.16639 16.5867 6.45737 16.5288C6.74834 16.4709 7.04994 16.5006 7.32403 16.6142C7.59811 16.7277 7.83238 16.92 7.9972 17.1666C8.16203 17.4133 8.25 17.7033 8.25 18C8.25 18.3978 8.09197 18.7794 7.81066 19.0607C7.52936 19.342 7.14783 19.5 6.75 19.5ZM14.3438 17.25H9.65625C9.49102 16.6047 9.11573 16.0327 8.58952 15.6243C8.06331 15.2158 7.41613 14.9941 6.75 14.9941C6.08387 14.9941 5.43669 15.2158 4.91048 15.6243C4.38428 16.0327 4.00898 16.6047 3.84375 17.25H2.25V14.25H15.75V15.4041C15.4051 15.6034 15.1032 15.8692 14.8619 16.1861C14.6205 16.5029 14.4444 16.8646 14.3438 17.25ZM17.25 19.5C16.9533 19.5 16.6633 19.412 16.4166 19.2472C16.17 19.0824 15.9777 18.8481 15.8642 18.574C15.7507 18.2999 15.7209 17.9983 15.7788 17.7074C15.8367 17.4164 15.9796 17.1491 16.1893 16.9393C16.3991 16.7296 16.6664 16.5867 16.9574 16.5288C17.2483 16.4709 17.5499 16.5006 17.824 16.6142C18.0981 16.7277 18.3324 16.92 18.4972 17.1666C18.662 17.4133 18.75 17.7033 18.75 18C18.75 18.3978 18.592 18.7794 18.3107 19.0607C18.0294 19.342 17.6478 19.5 17.25 19.5ZM21.75 17.25H20.1563C19.989 16.6063 19.613 16.0362 19.0871 15.629C18.5612 15.2218 17.9151 15.0006 17.25 15V12H21.75V17.25Z" fill="currentColor" /></svg>`;
		shippingCalcIcon.innerHTML = shippinIconHtml;
		shippingCalcIcon.classList.add('shipping-calc-icon');
		/* create a title */
		var shippingCalcTitle = document.createElement('h3');
		shippingCalcTitle.classList.add('shipping-calc-title');
		shippingCalcTitle.innerText = 'Calcular frete e prazo da entrega';
		shippingCalcTitle.appendChild(shippingCalcIcon);
		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerHTML = `<span>Ok</span><svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_966_1434)"><path d="M17.75 3V7.5H13.25" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8675 11.25C15.38 12.6299 14.4572 13.8141 13.2381 14.6239C12.0191 15.4337 10.5698 15.8254 9.10882 15.74C7.64779 15.6545 6.25412 15.0965 5.13782 14.15C4.02152 13.2036 3.24307 11.9199 2.91978 10.4926C2.59648 9.06518 2.74586 7.5714 3.3454 6.23631C3.94494 4.90122 4.96215 3.79716 6.24377 3.09049C7.52538 2.38382 9.00195 2.11284 10.451 2.31837C11.9 2.5239 13.243 3.19481 14.2775 4.23001L17.75 7.50001" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_966_1434"><rect width="18" height="18" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>`;
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick = function () {
			/* Efizi: a checagem de região saiu daqui — antes ela abria o modal em
			   cima do resultado (e, se o cliente trocava a região, a página
			   recarregava e o frete nunca aparecia). Agora o frete é calculado e
			   exibido primeiro; o aviso de região entra inline logo abaixo, via
			   updateRegionWarn(), chamado quando o resultado é renderizado. */
			if (!productSelect.value.length) { return false }
			if (shippingZip.value != '') {
				shippingCalcButton.innerHTML = '<span>Calculando</span>...';
				shippingCalcButton.className += ' disabled';
				/* dispara a busca da cidade em paralelo: a cotação leva alguns
				   segundos, então o nome já chega resolvido na hora de desenhar */
				buscaCidade(String(shippingZip.value).replace(/\D/g, ''));
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();
			/* if not found, make a new temp cookie */
			if (!cartCookie) {
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			} else {
				log('cookie found');
			}
			/* if found but has a weird length, bail */
			if (cartCookie.length < 32) { log('cart ID not valid'); return }
			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));
			getRates(parseInt(productSelect.value));
			return false;
		};
		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};
		shippingCalcWrapper.appendChild(shippingCalcTitle);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(shippingCalcNoZip);
		shippingCalcWrapper.appendChild(shippingMessage);
		shippingCalcWrapper.appendChild(regionWarn);
		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);
	};
	/* A console logging function */
	function log(a) {
		if (!debug) { return }
		console.log(a);
	};
	/* get cookie by name */
	var getCookie = function (name) {
		var value = "; " + document.cookie;
		var parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};
	/* update the cart cookie value */
	var updateCartCookie = function (a) {
		log('changing cart cookie value to: ' + a);
		var date = new Date();
		date.setTime(date.getTime() + (14 * 86400000));
		var expires = '; expires=' + date.toGMTString();
		document.cookie = 'cart=' + a + expires + '; path=/';
	};
	/* reset the cart cookie value */
	var resetCartCookie = function () {
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};
	/* get the rates */
	var getRates = function (variantId) {
		/* add whatever sanity checks you need in addition to the one below */
		if (typeof variantId === 'undefined') { return }
		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');
		var quantity = productQuantity ? parseInt(productQuantity.value) : 1;
		var addData = {
			'id': variantId,
			'quantity': quantity
		};
		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function (response) {
			return response.json();
		}).then(function (json) {
			/* we have JSON */
			//console.log(json);
			/* Change the cookie value back to what it was */
			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]': shippingCountry.value,
				'shipping_address[province]': shippingProvince.value,
				'shipping_address[zip]': shippingZip.value
			})).then(function (response) {
				if (!response.ok) {
					return response.json().then(function (errorData) {
						throw new Error('Não foi possível calcular o frete. Por favor, verifique o CEP e tente novamente.');
					});
				}
				return response.json();
			}).then(function (result) {
				if (result.shipping_rates && result.shipping_rates.length) {
					let messageHtml = '<ul>'
					for (let i = 0; i < result.shipping_rates.length; i++) {
						const element = result.shipping_rates[i];
						if (element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								var deliveryDays = '<span>1 dia útil</span>'
							} else {
								var deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`
							}
						}
						if (element.price > 0) {
							messageHtml += `
								<li>
									R$ ${element.price.replace('.', ',')} - ${deliveryDays ? deliveryDays : ''}
								</li>
							`;
						} else {
							messageHtml += `
								<li>
									<span style="color: #00AA00;">GRÁTIS</span> - ${deliveryDays ? deliveryDays : ''}
								</li>
							`;
						}
						if (i === result.shipping_rates.length) {
							messageHtml += '</ul>'
						}
					}
					shippingMessage.innerHTML = messageHtml;
				} else {
					shippingMessage.innerHTML = '<span style="color: #ff5414;">Não há opções de entrega disponíveis para este CEP.</span>';
				}
				/* Efizi: com o resultado na tela, avisa (inline) se o CEP é de outra região */
				updateRegionWarn(shippingZip.value, !!(result.shipping_rates && result.shipping_rates.length), result.shipping_rates);
				document.querySelector('.shippingCalcButton').innerHTML = `<span>Ok</span><svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_966_1434)"><path d="M17.75 3V7.5H13.25" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8675 11.25C15.38 12.6299 14.4572 13.8141 13.2381 14.6239C12.0191 15.4337 10.5698 15.8254 9.10882 15.74C7.64779 15.6545 6.25412 15.0965 5.13782 14.15C4.02152 13.2036 3.24307 11.9199 2.91978 10.4926C2.59648 9.06518 2.74586 7.5714 3.3454 6.23631C3.94494 4.90122 4.96215 3.79716 6.24377 3.09049C7.52538 2.38382 9.00195 2.11284 10.451 2.31837C11.9 2.5239 13.243 3.19481 14.2775 4.23001L17.75 7.50001" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_966_1434"><rect width="18" height="18" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>`;
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
				resetCartCookie();
			}).catch(function (error) {
				console.log(error);
				resetCartCookie();
				shippingMessage.innerHTML = `<span style="color: #ff5414;">${error.message}</span>`;
				/* Efizi: mesmo com erro na cotação, o aviso de região ajuda o cliente a se localizar */
				updateRegionWarn(shippingZip.value, false);
				document.querySelector('.shippingCalcButton').innerHTML = `<span>Ok</span><svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_966_1434)"><path d="M17.75 3V7.5H13.25" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8675 11.25C15.38 12.6299 14.4572 13.8141 13.2381 14.6239C12.0191 15.4337 10.5698 15.8254 9.10882 15.74C7.64779 15.6545 6.25412 15.0965 5.13782 14.15C4.02152 13.2036 3.24307 11.9199 2.91978 10.4926C2.59648 9.06518 2.74586 7.5714 3.3454 6.23631C3.94494 4.90122 4.96215 3.79716 6.24377 3.09049C7.52538 2.38382 9.00195 2.11284 10.451 2.31837C11.9 2.5239 13.243 3.19481 14.2775 4.23001L17.75 7.50001" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_966_1434"><rect width="18" height="18" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>`;
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
			})
		}).catch(function (err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});
	};
	initFields();
})()
